var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isShowHome)?_c('Header'):_vm._e(),_vm._v(" "),(!_vm.isShowHome)?_c('div',{staticClass:"app-main"},[_c('div',{staticClass:"app-main-left"},[_c('Menu')],1),_vm._v(" "),_c('div',{staticClass:"app-main-right"},[_c('router-view')],1)]):_vm._e(),_vm._v(" "),(_vm.isShowHome)?_c('div',[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b06e89e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 